<vi-page [sidenavs]="true" [footer]="true" [isWhiteBackground]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar head color="white">
    <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="booking"></vi-back-button>
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="booking"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      currentPage="{{ 'GENERAL.PATH.BOOKING' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>

  <vi-content body [centered]="true">
    <ng-container *ngIf="installationsStore.loaded$ | async; else loader" main>
      <mat-horizontal-stepper #stepper [selectedIndex]="currentStep">
        <mat-step #first_step>
          <ng-template matStepLabel>{{ '+BOOKING.STEPPER.SELECT_PLAN' | translate }}</ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
          </ng-template>

          <ng-container *ngIf="stepper.selected === null || stepper.selected === first_step">
            <app-booking-plans
              data-at-booking-overlay
              [selectedPlatform]="(route.queryParams | async).platform"
              [isBoilerSerialInQuery]="!!boilerSerial"
              (planSelected)="nextStep(stepper)"
              (navigateToCheckout)="navigateToCheckout(stepper)"
            ></app-booking-plans>
          </ng-container>
        </mat-step>
        <mat-step #second_step>
          <ng-template matStepLabel>{{
            '+BOOKING.STEPPER.SELECT_DEVICES' | translate
          }}</ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
          </ng-template>

          <ng-container *ngIf="stepper.selected === second_step">
            <button
              class="btn-back"
              mat-stroked-button
              gtm="onSelect"
              gtmAction="Booking Stepper"
              gtmCategory="booking"
              color="primary"
              (click)="previousStep(stepper)"
              data-at-back-button
            >
              {{ 'GENERAL.BUTTON.BACK' | translate }}
            </button>
            <app-booking-devices (nextPage)="nextStep(stepper)"></app-booking-devices>
          </ng-container>
        </mat-step>
        <mat-step #third_step>
          <ng-template matStepLabel>{{ '+BOOKING.STEPPER.CHECKOUT' | translate }}</ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
          </ng-template>

          <ng-container *ngIf="stepper.selected === third_step">
            <app-booking-checkout
              [selectedPlatform]="(route.queryParams | async).platform"
              (reset)="initialStep(stepper)"
              (back)="previousStep(stepper)"
            ></app-booking-checkout>
          </ng-container>
        </mat-step>
      </mat-horizontal-stepper>
    </ng-container>
  </vi-content>
  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>

<ng-template #loader>
  <vi-loader main data-at-loader [isLoading]="true"></vi-loader>
</ng-template>
